var map = {
	"./bg-BG.json": "a84a",
	"./cs-CZ.json": "6cd8",
	"./da-DK.json": "975e",
	"./de-DE.json": "6922",
	"./el-GR.json": "36de",
	"./en-US.json": "e0e1",
	"./es-ES.json": "41092",
	"./et-EE.json": "bba7",
	"./fi-FI.json": "0917",
	"./fr-FR.json": "cfe42",
	"./hr-HR.json": "4ad0",
	"./hu-HU.json": "5846",
	"./it-IT.json": "bf7d",
	"./ja-JP.json": "2b1b",
	"./lt-LT.json": "cf0a",
	"./lv-LV.json": "5448",
	"./nl-NL.json": "0727",
	"./pl-PL.json": "ace3",
	"./pt-PT.json": "7b75",
	"./ro-RO.json": "24ef",
	"./ru-RU.json": "b69a",
	"./sk-SK.json": "e185",
	"./sl-SI.json": "a0ac",
	"./sv-FI.json": "c038",
	"./sv-SE.json": "b48e",
	"./tr-TR.json": "3ba8",
	"./zh-CN.json": "423e"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "49f8";